/**
 * @desc:公共方法集合
 */
// import axios from 'axios'
import { lang } from './filters'
import { cacheHelper } from './cacheHelper'
import Vue from 'vue'
import store from '@/store'
import cloneDeep from 'lodash/cloneDeep'
const stringType = Object.prototype.toString
// const userInfo = JSON.parse(localStorage.getItem('userData'))
import * as Api from '@api/base/public'
import { RESPONSE_SUCCESS } from '@constants'

export const commonFun = {
  // 获取数据词典
  async getDict(type, valType = 'id') {
    const { data, code } = await Api.getSysDictionary() // 根据运单号
    const dataList = []
    if (code === RESPONSE_SUCCESS) {
      const dictList = data || []
      dictList.forEach(item => {
        if (item.code === type) {
          item.child.forEach(item2 => {
            dataList.push({ value: +item2[valType], label: lang(item2.localName || item2.name), name: item2.localName || item2.name, code: item2.code, id: item2.id })
          })
        }
      })
      return dataList
    } else {
      // this.$message.error(msg)
      return []
    }
  },

  conver(s) {
    return s < 10 ? '0' + s : s
  },
  getCurDate() {
    const myDate = new Date()

    // 获取当前年
    const year = myDate.getFullYear()

    // 获取当前月
    const month = myDate.getMonth() + 1

    // 获取当前日
    const date = myDate.getDate()
    const h = myDate.getHours() // 获取当前小时数(0-23)
    const m = myDate.getMinutes() // 获取当前分钟数(0-59)
    const s = myDate.getSeconds()

    // 获取当前时间
    const day = year + '-' + commonFun.conver(month) + '-' + commonFun.conver(date)
    const hour = commonFun.conver(h) + ':' + commonFun.conver(m) + ':' + commonFun.conver(s)
    const now = day + ' ' + hour
    return {
      dayHour: now,
      day,
      hour,
    }
  },
  /**
   * @Title 是否为空判断
   * @Description TODO
   * @author xzd
   * @param val
   * @returns {Boolean} 空返回true
   */
  isEmpty(val) {
    if (typeof val === 'string' || val instanceof String) {
      val = val.replace(/\s/g, '')
    }
    if (val === null) {
      return 1
    }
    if (val === undefined || val === 'undefined') {
      return 1
    }
    if (val === '') {
      return 1
    }
    if (val.length === 0) {
      return 1
    }
    if (!/[^(^\s*)|(\s*$)]/.test(val)) {
      return 1
    }
    return 0
  },
  /**
   * @Title 判断obj对象是否没有属性
   * @Description 没有返回true
   * @param obj 只接收obj
   * @returns {boolean}
   */
  isEmptyProperty(obj) {
    let key
    for (key in obj) {
      if (obj.hasOwnProperty(key)) {
        return 0 //  不为空返回false
      }
    }
    return 1 //  空返回true
  },
  // 获取当天的开始与结束日期
  GetTodayDate(addDate = 0, addTime = true) {
    var dd = new Date()
    dd.setDate(dd.getDate() + addDate) // 获取第addDate天后的日期
    var y = dd.getFullYear()
    var m = dd.getMonth() + 1 < 10 ? '0' + (dd.getMonth() + 1) : dd.getMonth() + 1 // 获取当前月份的日期，不足10补0
    var d = dd.getDate() < 10 ? '0' + dd.getDate() : dd.getDate() // 获取当前几号，不足10补0
    let start = y + '-' + m + '-' + d
    addTime ? (start = start + ' ' + '00:00:00') : ''
    let end = y + '-' + m + '-' + d
    addTime ? (end = end + ' ' + '23:59:59') : ''
    return [start, end]
  },

  // 获取n天前的时间
  GetBeforeTime() {

  },

  // 格式化年月
  formatMonth(month, year) {
    return `${year}-${month.toString().padStart(2, '0')}`;
  },

  // 格式化年月日
  formatDate(date) {
    const year = date.getFullYear()
    const month = (date.getMonth() + 1).toString().padStart(2, '0')
    const day = date.getDate().toString().padStart(2, '0')
    return `${year}-${month}-${day}`
  },

  // 获取当天日期的前7天日期
  getBeforeDate(n, type = '-') {
    const d = new Date()
    let year = d.getFullYear()
    let mon = d.getMonth() + 1
    let day = d.getDate()
    if (day <= n) {
      if (mon > 1) {
        mon = mon - 1
      } else {
        year = year - 1
        mon = 12
      }
    }
    d.setDate(d.getDate() - n)
    year = d.getFullYear()
    mon = d.getMonth() + 1
    day = d.getDate()
    const s = year + type + (mon < 10 ? '0' + mon : mon) + type + (day < 10 ? '0' + day : day)
    return s
  },
  // 16进制颜色转换
  hexToRgb(hex) {
    var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex)
    return result ? {
      r: parseInt(result[1], 16),
      g: parseInt(result[2], 16),
      b: parseInt(result[3], 16),
    } : null
  },
  /**
     * 对象深拷贝
     */
  deepClone(data) {
    var type = this.getObjType(data)
    var obj
    if (type === 'array') {
      obj = []
    } else if (type === 'object') {
      obj = {}
    } else {
      // 不再具有下一层次
      return data
    }
    if (type === 'array') {
      for (var i = 0, len = data.length; i < len; i++) {
        delete data[i].$parent
        obj.push(this.deepClone(data[i]))
      }
    } else if (type === 'object') {
      for (var key in data) {
        delete data.$parent
        obj[key] = this.deepClone(data[key])
      }
    }
    return obj
  },
  getObjType(obj) {
    var toString = Object.prototype.toString
    var map = {
      '[object Boolean]': 'boolean',
      '[object Number]': 'number',
      '[object String]': 'string',
      '[object Function]': 'function',
      '[object Array]': 'array',
      '[object Date]': 'date',
      '[object RegExp]': 'regExp',
      '[object Undefined]': 'undefined',
      '[object Null]': 'null',
      '[object Object]': 'object',
    }
    if (obj instanceof Element) {
      return 'element'
    }
    return map[toString.call(obj)]
  },
}

/*
 *@Description: 判断当前模块是否有对应的操作权限
 *@param {arg} moduleName type
 *@return [Boolean]
 *@Date: 2019-07-03 10:52:04
 */
export function hasPower(moduleName, type) {
  let btnList = store.state.base.btnList || {}
  let power = {}
  if (btnList[moduleName]) {
    power = btnList[moduleName]
  } else {
    btnList = cacheHelper.get('btnList')
    if (btnList) power = btnList[moduleName]
  }
  return power[type] || false
}

/*
 *@Description: 全局eventBus
 *@param {arg} type
 *@return [type]
 *@Date: 2019-07-11 15:51:09
 */
export const bus = new Vue()

/*
 *@Description: 将时间数组输出成两个属性并赋值给表单 编辑将两个属性合成一个数组
 *@param {arg} type
 *@return [type]
 *@Date: 2019-07-17 18:59:11
 */

export function timeRangeHandler(form, prop) {
  // 提交处理
  const reslut = form[prop]
  if (reslut) {
    if (Array.isArray(reslut)) {
      form[prop + 'StartTime'] = reslut[0]
      form[prop + 'EndTime'] = reslut[1]
      delete form[prop]
    }
  }
  // 编辑回选处理
  const start = form[prop + 'StartTime']
  const end = form[prop + 'EndTime']
  if (start && end) {
    form[prop] = [start, end]
  }
  return form
}

export const debounce = (fn, delay) => {
  let timer
  return function(...args) {
    if (timer) {
      clearTimeout(timer)
    }
    timer = setTimeout(() => {
      fn.apply(this, args)
    }, delay)
  }
}

export const renameKeys = (keysMap = {}, obj) => {
  return Object.keys(obj).reduce((acc, val) => {
    return {
      ...acc,
      [keysMap[val] || val]: obj[val],
    }
  }, {})
}

export const difference = (a, b) => {
  const arr1 = new Set(a)
  const arr2 = new Set(b)
  return [...b.filter(x => !arr1.has(x)), ...a.filter(x => !arr2.has(x))]
}

/*
 *@Description: 将表单字段的值从对象变为 xxxName xxxCode xxxId
 *@param {arg} form =>要转换的表单; exclude =>不需要转换的字段
 *@return [type] Object
 *@Date: 2019-08-21 16:25:12
 */

export function deconstrucForm(form, exclude = []) {
  const data = cloneDeep(form)
  Object.keys(data).forEach(prop => {
    const value = data[prop]
    const has$ = prop.substr(0, 1) === '$'
    if (stringType.call(value) === '[object Object]' && !has$ && !exclude.includes(prop)) {
      data[prop + 'Code'] = value.code
      data[prop + 'Name'] = value.name
      data[prop + 'Id'] = value.id
      delete data[prop]
    }
    if (has$) {
      delete data[prop]
    }
  })
  return data
}

export function resolveForm(form, resolveProps = []) {
  const data = {}
  Object.keys(form).forEach(prop => {
    const value = form[prop]
    const has$ = prop.substr(0, 1) === '$'
    if (stringType.call(value) === '[object Object]' && !has$ && resolveProps.includes(prop)) {
      data[prop + 'Code'] = value.code
      data[prop + 'Name'] = value.name
      data[prop + 'Id'] = value.id
      delete data[prop]
    }
  })
  return data
}

export function combineForm(form, props = []) {
  const data = cloneDeep(form)
  props.forEach(prop => {
    data[prop] = {
      name: data[prop + 'Name'],
      code: data[prop + 'Code'],
      id: data[prop + 'Id'],
    }
    delete data[prop + 'Name']
    delete data[prop + 'Code']
    delete data[prop + 'Id']
  })
  return data
}

/**
 * 根据id查找tree中【匹配的元素
 * @param { Array } list 目标列表 必填
 * @param { any } id 查找标识 -唯一 必填
 * @param { String } key 目标列表的匹配键值 默认为id
 */
export const findEleForTreeByKey = (list, id, key = 'id') => {
  if (!list || !Array.isArray(list)) throw new Error('type of list is error!')
  if (id === undefined || id === null || id === '') throw new Error('id can not empty!')
  let stack = [] // 数据栈列表
  let item = null // 当前栈数据
  let result = null // 符合条件的结果
  if (!list || !list.length) return // 初始数据不存在则返回
  // 将第一层节点放入栈
  stack = [...list]
  // 遍历
  while (stack.length) {
    item = stack.shift() // 取出第一个栈数据
    const child = item.children // 当前栈数据的子节点
    // 符合条件则赋值给result，同时中断循环
    if (item[key] === id) {
      result = item
      break
    }
    // 如果子节点存在，则添加到数据栈
    if (child && child.length) {
      stack = stack.concat(child)
    }
  }
  // 返回结果
  return result
}

/*
 *@Description: 判断是否为空
 *@param {arg} any
 *@return [type] 空值返回真 其他返回假
 *@Date: 2019-06-21 16:01:51
 */
export function validatenull(val) {
  if (typeof val === 'boolean') {
    return false
  }
  if (typeof val === 'number') {
    return false
  }
  if (val instanceof Array) {
    if (val.length === 0) return true
  } else if (val instanceof Object) {
    if (JSON.stringify(val) === '{}') return true
  } else {
    if (val === 'null' || val == null || val === 'undefined' || val === undefined || val === '') {
      return true
    }
    return false
  }
  return false
}

/**
 * 转换名称首个字母为大写
 * @param { String } name 需要转换的名称
 */
export const nameToUpperCase = name => name.charAt(0).toUpperCase() + name.substr(1)

/**
 * 截取浮点数的小数后几位
 * @param {*} value 需要截取的数字|字符串
 * @param {*} len 截取小数后的长度
 */
export const floatNumSub = (value, len = 2) => {
  if (!value && value !== 0) return console.warn('floatNumSub::warb', '请传入正确参数')
  const type = typeof value
  if (type === 'string') {
    value = Number(value)
    const v = value.toFixed(len)
    return parseFloat(v)
  } else if (type === 'number') {
    const v = value.toFixed(len)
    return parseFloat(v)
  } else {
    return value
  }
}

/*
 *@Description: 复制文本
*/
export const copyText = txt => {
  if (typeof txt !== 'string' || !txt.length) {
    return
  }
  let txtEl = document.createElement('input')
  txtEl.setAttribute('type', 'text')
  txtEl.setAttribute('value', txt)
  txtEl.style.position = 'fixed'
  txtEl.style.left = '-999999px'
  txtEl.style.top = '-9999px'
  document.body.appendChild(txtEl)
  txtEl.select()
  document.execCommand('copy')
  document.body.removeChild(txtEl)
  txtEl = null
}

/**
 *判断是否为json对象
 */
export const isJson = str => {
  if (Array.isArray(str)) {
    if (str[0] instanceof Object) {
      return true
    } else {
      return false
    }
  } else if (str instanceof Object) {
    return true
  }
  return false
}

export const getCookie = (key) => {
  const cookie = document.cookie
  const length = cookie.length
  if (length) {
    let start = cookie.indexOf(key + '=')
    if (start !== -1) {
      start = start + key.length + 1
      let end = cookie.indexOf(';', start)
      if (end === -1) end = length
      return unescape(cookie.substring(start, end))
    }
  }
  return ''
}

export const setCookie = (cName, value, expiredays) => {
  const exdate = new Date()
  exdate.setDate(exdate.getDate() + expiredays)
  document.cookie = cName + '=' + decodeURIComponent(value) + (expiredays == null ? '' : ';expires=' + exdate.toGMTString())
}
